// The application identifier, used for build output filenames and app config.
export const APP_NAME = 'auth';
